// import React, { useEffect, useState } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import { Tooltip } from "@mui/material";
// import { useDispatch } from "react-redux";
// import { approveAccessRequest, rejectAccessRequest } from "../../contents/redux/actions/accessRequestActions";
// import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
// import RejectRequestModal from "./RejectRequestModal";
// import styles from "../utilities/cssmodules/AccessRequestsApprovals.module.css";

// const ViewAccessRequestContent = () => {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const request = location.state?.request;


//   const [isQueryModalOpen, setIsQueryModalOpen] = useState(false);
//   const [isRejectModalOpen, setIsRejectModalOpen] = useState(false);

//   useEffect(() => {
//   if (request) {
//     console.log("🔍 Access Request Data (Full):");
//     console.dir(request, { depth: null }); // shows nested structure clearly

//     // Or stringify with formatting
//     console.log("🔍 Access Request JSON:", JSON.stringify(request, null, 2));
//   }
// }, [request]);




//   if (!request) {
//     navigate("/accessrequests");
//     return null;
//   };

//   const goBack = () => navigate(-1);

// //   Approval handling
// const handleApproval = () => {
//     if (!request?.id) return;
//     dispatch(approveAccessRequest(request.id)).then(() => {
//         navigate('/accessrequests'); //Go back to access requests after approving
//     });
// };

// //   Rejection handling
// const handleRejection = () => {
//     if (!request?.id) return;
//     dispatch(rejectAccessRequest(request.id)).then(() => {
//         navigate('/accessrequests'); //Go back to access requests after rejecting
//     });
// };


//   return (

//     <div className={styles["component-wrapper"]}>
//         <div className={styles["component-title"]}>
//         <div className={styles["flex-row-container"]}>
//           <div className={styles["flex-row-custom-1"]}>
//             <span className={styles["title-back-button"]} onClick={goBack} aria-label="Go Back">
//               <Tooltip title="Go Back" arrow placement="top">
//                 <ArrowBackIosIcon />
//               </Tooltip>
//             </span>
//             <span>View Access Request</span>
//           </div>
//         </div>
//       </div>

//       <div className={styles["wrapper"]}>
//         <div className={styles["generic_request_content_component_wrapper"]}>
//             <div className={styles["generic_request_content_wrapper"]}>
//                 <div className={styles["request-details-header"]}>
//                     <div className={styles["section-header"]}>
//                         Access Request Details For {request?.companyName}
//                         {/* <p>
//                             View details and perform actions for <b>{request?.companyName}</b>
//                         </p> */}
//                     </div>
//                 </div>
//                 <div className={styles["status-container"]}>
//                     <p>
//                         Status:{" "}
//                         <span className={`${styles["status-badge"]} ${
//                             request?.statusName === "Rejected"
//                             ? styles["status-rejected"]
//                             : request?.statusName === "Submitted"
//                             ? styles["status-submitted"]
//                             : ""
//                         }`}
//                         >
//                         {request?.statusName || "N/A"}
//                         </span>
//                     </p>
//                 </div>




//                 <div className={styles["generic_request_content_container"]}>
//                     <div className={styles["generic_request_content"]}>
//                         <div className={styles["generic_request_content_heading"]}>Company Name:</div>
//                         <div className={styles["generic_request_content_data"]}>{request.companyName || "N/A"}</div>
//                     </div>

//                     <div className={styles["generic_request_content"]}>
//                         <div className={styles["generic_request_content_heading"]}>Business Registration Number:</div>
//                         <div className={styles["generic_request_content_data"]}>{request.businessRegistrationNumber || "N/A"}</div>
//                     </div>

//                     <div className={styles["generic_request_content"]}>
//                         <div className={styles["generic_request_content_heading"]}>Tax Identification Number:</div>
//                         <div className={styles["generic_request_content_data"]}>{request.tin || "N/A"}</div>
//                     </div>

//                     <div className={styles["generic_request_content"]}>
//                         <div className={styles["generic_request_content_heading"]}>Business Address:</div>
//                         <div className={styles["generic_request_content_data"]}>{request.businessAddress || "N/A"}</div>
//                     </div>

//                     <div className={styles["generic_request_content"]}>
//                         <div className={styles["generic_request_content_heading"]}>Admin Fullname:</div>
//                         <div className={styles["generic_request_content_data"]}>{request.contactPerson || "N/A"}</div>
//                     </div>

//                     <div className={styles["generic_request_content"]}>
//                         <div className={styles["generic_request_content_heading"]}>Email:</div>
//                         <div className={styles["generic_request_content_data"]}>{request.email || "N/A"}</div>
//                     </div>

//                     <div className={styles["generic_request_content"]}>
//                         <div className={styles["generic_request_content_heading"]}>Cell Number:</div>
//                         <div className={styles["generic_request_content_data"]}>{request.cellNumber || "N/A"}</div>
//                     </div>

//                     <div className={styles["generic_request_content"]}>
//                         <div className={styles["generic_request_content_heading"]}>Request Date:</div>
//                         <div className={styles["generic_request_content_data"]}>
//                             {request.createdDate
//                                 ? new Date(request.createdDate).toLocaleDateString("en-US", {
//                                     year: "numeric",
//                                     month: "long",
//                                     day: "numeric",
//                                 })
//                             : "N/A"}
//                         </div>
//                     </div>

//                     {request?.statusName === "Submitted" && (
//                         <div className={styles["generic_request_actions_wrapper"]}>
//                             <div className={styles["actions-header"]}></div>
//                             <div className={styles["generic_request_actions"]}>
//                             <button
//                                 className={styles["generic_request_button_primary"]}
//                                 onClick={handleApproval}
//                             >
//                                 Approve
//                             </button>
//                             {/* <button
//                                 className={styles["generic_request_button_secondary"]}
//                                 onClick={() => setIsQueryModalOpen(true)}
//                             >
//                                 Query
//                             </button> */}
//                             <button
//                                 className={styles["generic_request_button_danger"]}
//                                 onClick={handleRejection}
//                             >
//                                 Reject
//                             </button>
//                             {/* <button
//                                 className={styles["generic_request_button_danger"]}
//                                 onClick={() => setIsRejectModalOpen(true)}
//                             >
//                                 Reject
//                             </button> */}
//                             </div>
//                         </div>
//                     )}

//                 </div>
//             </div>
//         </div>
//       </div>

//       <RejectRequestModal
//         isModalVisible={isRejectModalOpen}
//         request={request}
//         onClose={() => setIsRejectModalOpen(false)}
//       />
//     </div>
//   );
// };

// export default ViewAccessRequestContent;































// import React, { useEffect, useState } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import { Tooltip } from "@mui/material";
// import { useDispatch } from "react-redux";
// import { approveAccessRequest, rejectAccessRequest } from "../../contents/redux/actions/accessRequestActions";
// import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
// import RejectAccessRequestModal from "./RejectAccessRequestModal";
// import styles from "../utilities/cssmodules/AccessRequestsApprovals.module.css";

// const ViewAccessRequestContent = () => {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const request = location.state?.request;

//   const [isRejectModalOpen, setIsRejectModalOpen] = useState(false);

//   useEffect(() => {
//     if (request) {
//       console.log("🔍 Access Request Data (Full):");
//       console.dir(request, { depth: null });
//       console.log("🔍 Access Request JSON:", JSON.stringify(request, null, 2));
//     }
//   }, [request]);

//   if (!request) {
//     navigate("/accessrequests");
//     return null;
//   }

//   const goBack = () => navigate(-1);

//   // ✅ Approve request
//   const handleApproval = () => {
//     if (!request?.id) return;
//     dispatch(approveAccessRequest(request.id)).then(() => {
//       navigate("/accessrequests");
//     });
//   };

//   // ✅ Handle reject submit from modal
//   const handleRejectionSubmit = (comment) => {
//     if (!request?.id) return;
//     dispatch(rejectAccessRequest(request.id, comment)).then(() => {
//       setIsRejectModalOpen(false);
//       navigate("/accessrequests");
//     });
//   };

//   return (
//     <div className={styles["component-wrapper"]}>
//       <div className={styles["component-title"]}>
//         <div className={styles["flex-row-container"]}>
//           <div className={styles["flex-row-custom-1"]}>
//             <span className={styles["title-back-button"]} onClick={goBack} aria-label="Go Back">
//               <Tooltip title="Go Back" arrow placement="top">
//                 <ArrowBackIosIcon />
//               </Tooltip>
//             </span>
//             <span>View Access Request</span>
//           </div>
//         </div>
//       </div>

//       <div className={styles["wrapper"]}>
//         <div className={styles["generic_request_content_component_wrapper"]}>
//           <div className={styles["generic_request_content_wrapper"]}>
//             <div className={styles["request-details-header"]}>
//               <div className={styles["section-header"]}>
//                 Access Request Details For {request?.companyName}
//               </div>
//             </div>

//             <div className={styles["status-container"]}>
//               <p>
//                 Status:{" "}
//                 <span
//                   className={`${styles["status-badge"]} ${
//                     request?.statusName === "Rejected"
//                       ? styles["status-rejected"]
//                       : request?.statusName === "Submitted"
//                       ? styles["status-submitted"]
//                       : ""
//                   }`}
//                 >
//                   {request?.statusName || "N/A"}
//                 </span>
//               </p>
//             </div>

//             <div className={styles["generic_request_content_container"]}>
//               <div className={styles["generic_request_content"]}>
//                 <div className={styles["generic_request_content_heading"]}>Company Name:</div>
//                 <div className={styles["generic_request_content_data"]}>
//                   {request.companyName || "N/A"}
//                 </div>
//               </div>

//               <div className={styles["generic_request_content"]}>
//                 <div className={styles["generic_request_content_heading"]}>Business Registration Number:</div>
//                 <div className={styles["generic_request_content_data"]}>
//                   {request.businessRegistrationNumber || "N/A"}
//                 </div>
//               </div>

//               <div className={styles["generic_request_content"]}>
//                 <div className={styles["generic_request_content_heading"]}>Tax Identification Number:</div>
//                 <div className={styles["generic_request_content_data"]}>
//                   {request.tin || "N/A"}
//                 </div>
//               </div>

//               <div className={styles["generic_request_content"]}>
//                 <div className={styles["generic_request_content_heading"]}>Business Address:</div>
//                 <div className={styles["generic_request_content_data"]}>
//                   {request.businessAddress || "N/A"}
//                 </div>
//               </div>

//               <div className={styles["generic_request_content"]}>
//                 <div className={styles["generic_request_content_heading"]}>Admin Fullname:</div>
//                 <div className={styles["generic_request_content_data"]}>
//                   {request.contactPerson || "N/A"}
//                 </div>
//               </div>

//               <div className={styles["generic_request_content"]}>
//                 <div className={styles["generic_request_content_heading"]}>Email:</div>
//                 <div className={styles["generic_request_content_data"]}>
//                   {request.email || "N/A"}
//                 </div>
//               </div>

//               <div className={styles["generic_request_content"]}>
//                 <div className={styles["generic_request_content_heading"]}>Cell Number:</div>
//                 <div className={styles["generic_request_content_data"]}>
//                   {request.cellNumber || "N/A"}
//                 </div>
//               </div>

//               <div className={styles["generic_request_content"]}>
//                 <div className={styles["generic_request_content_heading"]}>Request Date:</div>
//                 <div className={styles["generic_request_content_data"]}>
//                   {request.createdDate
//                     ? new Date(request.createdDate).toLocaleDateString("en-US", {
//                         year: "numeric",
//                         month: "long",
//                         day: "numeric",
//                       })
//                     : "N/A"}
//                 </div>
//               </div>

//               {request?.statusName === "Submitted" && (
//                 <div className={styles["generic_request_actions_wrapper"]}>
//                   <div className={styles["actions-header"]}></div>
//                   <div className={styles["generic_request_actions"]}>
//                     <button
//                       className={styles["generic_request_button_primary"]}
//                       onClick={handleApproval}
//                     >
//                       Approve
//                     </button>
//                     <button
//                       className={styles["generic_request_button_danger"]}
//                       onClick={() => setIsRejectModalOpen(true)}
//                     >
//                       Reject
//                     </button>
//                   </div>
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* ✅ Rejection Modal */}
//       <RejectAccessRequestModal
//         open={isRejectModalOpen}
//         onClose={() => setIsRejectModalOpen(false)}
//         onSubmit={handleRejectionSubmit}
//         workflowId={request?.workflowId}
//         requester={request?.contactPerson}
//         requesterId={request?.requesterId}
//       />
//     </div>
//   );
// };

// export default ViewAccessRequestContent;










import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Tooltip } from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import RejectAccessRequestModal from "./RejectAccessRequestModal";
import {
  fetchAccessRequestDetails,
  approveAccessRequest,
  rejectAccessRequest,
} from "../../contents/redux/actions/accessRequestActions";
import styles from "../utilities/cssmodules/AccessRequestsApprovals.module.css";

const ViewAccessRequestContent = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const requestId = location.state?.requestId;

  const { details, detailsLoading, detailsError } = useSelector(
    (state) => state.accessApprovalRequests
  );

  const [isRejectModalOpen, setIsRejectModalOpen] = useState(false);

  // Fetch request details on mount
  useEffect(() => {
    if (!requestId) {
      navigate("/accessrequests");
      return;
    }
    dispatch(fetchAccessRequestDetails(requestId));
  }, [requestId, dispatch, navigate]);

  // Redirect if requestId is missing
  if (!requestId) return null;

  const goBack = () => navigate(-1);

  // Function to open base64 document in a new tab
  const handleViewDocument = () => {
    if (!details?.businessRegistrationDocumentBase64) return;

    // Convert Base64 to binary
    const byteCharacters = atob(details.businessRegistrationDocumentBase64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);

    // Create a Blob (assuming PDF, change type if needed)
    const blob = new Blob([byteArray], { type: "application/pdf" });

    // Create a URL and open in a new tab
    const blobUrl = URL.createObjectURL(blob);
    window.open(blobUrl, "_blank");
  };



  const handleApproval = () => {
    if (!details?.id) return;
    dispatch(approveAccessRequest(details.id)).then(() => {
      navigate("/accessrequests");
    });
  };

  const handleRejectionSubmit = (comment) => {
    if (!details?.id) return;
    dispatch(rejectAccessRequest(details.id, comment)).then(() => {
      setIsRejectModalOpen(false);
      navigate("/accessrequests");
    });
  };

  if (detailsLoading) {
    return (
      <div className={styles["component-wrapper"]}>
        <p>Loading...</p>
      </div>
    );
  }

  if (detailsError) {
    return (
      <div className={styles["component-wrapper"]}>
        <p>Error: {detailsError}</p>
      </div>
    );
  }

  if (!details) {
    return null; // Safety fallback
  }

  return (
    <div className={styles["component-wrapper"]}>
      <div className={styles["component-title"]}>
        <div className={styles["flex-row-container"]}>
          <div className={styles["flex-row-custom-1"]}>
            <span
              className={styles["title-back-button"]}
              onClick={goBack}
              aria-label="Go Back"
            >
              <Tooltip title="Go Back" arrow placement="top">
                <ArrowBackIosIcon />
              </Tooltip>
            </span>
            <span>View Access Request</span>
          </div>
        </div>
      </div>

      <div className={styles["wrapper"]}>
        <div className={styles["generic_request_content_component_wrapper"]}>
          <div className={styles["generic_request_content_wrapper"]}>
            <div className={styles["request-details-header"]}>
              <div className={styles["section-header"]}>
                Access Request Details For {details?.companyName}
              </div>
            </div>

            <div className={styles["status-container"]}>
              <p>
                Status:{" "}
                <span
                  className={`${styles["status-badge"]} ${
                    details?.statusName === "Rejected"
                      ? styles["status-rejected"]
                      : details?.statusName === "Submitted"
                      ? styles["status-submitted"]
                      : ""
                  }`}
                >
                  {details?.statusName || "N/A"}
                </span>
              </p>
            </div>

            <div className={styles["generic_request_content_container"]}>
              <div className={styles["generic_request_content"]}>
                <div className={styles["generic_request_content_heading"]}>
                  Company Name:
                </div>
                <div className={styles["generic_request_content_data"]}>
                  {details.companyName || "N/A"}
                </div>
              </div>

              <div className={styles["generic_request_content"]}>
                <div className={styles["generic_request_content_heading"]}>
                  Business Degistration Document:
                </div>
                <div className={styles["generic_request_content_data"]}>
                 <button className={styles["generic_request_button_secondary"]} onClick={handleViewDocument}>View document</button>
                </div>
              </div>

              <div className={styles["generic_request_content"]}>
                <div className={styles["generic_request_content_heading"]}>
                  Business Registration Number:
                </div>
                <div className={styles["generic_request_content_data"]}>
                  {details.businessRegistrationNumber || "N/A"}
                </div>
              </div>

              <div className={styles["generic_request_content"]}>
                <div className={styles["generic_request_content_heading"]}>
                  Tax Identification Number:
                </div>
                <div className={styles["generic_request_content_data"]}>
                  {details.tin || "N/A"}
                </div>
              </div>

              <div className={styles["generic_request_content"]}>
                <div className={styles["generic_request_content_heading"]}>
                  Business Address:
                </div>
                <div className={styles["generic_request_content_data"]}>
                  {details.businessAddress || "N/A"}
                </div>
              </div>

              <div className={styles["generic_request_content"]}>
                <div className={styles["generic_request_content_heading"]}>
                  Admin Fullname:
                </div>
                <div className={styles["generic_request_content_data"]}>
                  {details.contactPerson || "N/A"}
                </div>
              </div>

              <div className={styles["generic_request_content"]}>
                <div className={styles["generic_request_content_heading"]}>
                  Email:
                </div>
                <div className={styles["generic_request_content_data"]}>
                  {details.email || "N/A"}
                </div>
              </div>

              <div className={styles["generic_request_content"]}>
                <div className={styles["generic_request_content_heading"]}>
                  Cell Number:
                </div>
                <div className={styles["generic_request_content_data"]}>
                  {details.cellNumber || "N/A"}
                </div>
              </div>

              <div className={styles["generic_request_content"]}>
                <div className={styles["generic_request_content_heading"]}>
                  Request Date:
                </div>
                <div className={styles["generic_request_content_data"]}>
                  {details.createdDate
                    ? new Date(details.createdDate).toLocaleDateString("en-US", {
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                      })
                    : "N/A"}
                </div>
              </div>

              {details?.statusName === "Submitted" && (
                <div className={styles["generic_request_actions_wrapper"]}>
                  <div className={styles["actions-header"]}></div>
                  <div className={styles["generic_request_actions"]}>
                    <button
                      className={styles["generic_request_button_primary"]}
                      onClick={handleApproval}
                    >
                      Approve
                    </button>
                    <button
                      className={styles["generic_request_button_danger"]}
                      onClick={() => setIsRejectModalOpen(true)}
                    >
                      Reject
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <RejectAccessRequestModal
        open={isRejectModalOpen}
        onClose={() => setIsRejectModalOpen(false)}
        onSubmit={handleRejectionSubmit}
        workflowId={details?.workflowId}
        requester={details?.contactPerson}
        requesterId={details?.requesterId}
      />
    </div>
  );
};

export default ViewAccessRequestContent;
